/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CitasConfirmacionControllerActualizarCitaConfirmacion$Params {

/**
 * UUID de la cita
 */
  uuidCita: string;

/**
 * ID de la selene
 */
  idSelene: string;
}

export function citasConfirmacionControllerActualizarCitaConfirmacion(http: HttpClient, rootUrl: string, params: CitasConfirmacionControllerActualizarCitaConfirmacion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, citasConfirmacionControllerActualizarCitaConfirmacion.PATH, 'put');
  if (params) {
    rb.path('uuidCita', params.uuidCita, {});
    rb.path('idSelene', params.idSelene, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

citasConfirmacionControllerActualizarCitaConfirmacion.PATH = '/api/citas-confirmacion/{uuidCita}/{idSelene}';
